import { render, staticRenderFns } from "./PopupBase.vue?vue&type=template&id=e17a1b4c&scoped=true&lang=pug&"
import script from "./PopupBase.vue?vue&type=script&lang=ts&"
export * from "./PopupBase.vue?vue&type=script&lang=ts&"
import style0 from "./PopupBase.vue?vue&type=style&index=0&id=e17a1b4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17a1b4c",
  null
  
)

export default component.exports